import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export default styled(Button)`
  margin: 16px 12px 0 auto;
  width: 40%;
  background-color: white;
  font-weight: bold;
`;
